module.exports = __webpack_public_path__ + "static/media/loading_ring.dae10a71.gif";